export var ComparisonMode;
(function (ComparisonMode) {
    ComparisonMode["DayMinusOneAndDayMinusEight"] = "dayMinusOneAndDayMinusEight";
    ComparisonMode["DayMinusOneAndDayMinusTwo"] = "dayMinusOneAndDayMinusTwo";
    ComparisonMode["WeekMinusOneAndWeekMinusTwo"] = "weekMinusOneAndWeekMinusTwo";
})(ComparisonMode || (ComparisonMode = {}));
export const ComparisonModeKey = {
    dayMinusOneAndDayMinusTwo: 'COMPARISON_MODE.DAY_MINUS_TWO',
    dayMinusOneAndDayMinusEight: 'COMPARISON_MODE.DAY_MINUS_EIGHT',
    weekMinusOneAndWeekMinusTwo: 'COMPARISON_MODE.WEEK_MINUS_TWO',
};
export const ComparisonModeKeyV2 = {
    [ComparisonMode.DayMinusOneAndDayMinusEight]: 'COMPARISON_MODE.DAY_ONE_VS_DAY_EIGHT',
    [ComparisonMode.DayMinusOneAndDayMinusTwo]: 'COMPARISON_MODE.DAY_OVER_DAY',
    [ComparisonMode.WeekMinusOneAndWeekMinusTwo]: 'COMPARISON_MODE.WEEK_OVER_WEEK',
};
//# sourceMappingURL=comparison.mode.js.map